import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import ModalVideo from "react-modal-video";
import ResponsiveEmbed from "react-responsive-embed";

function PackageDetailsTab(props) {

  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="package-details-tabs">
        <ul
          className="nav nav-pills tab-switchers gap-xxl-4 gap-3"
          id="pills-tab"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="pills-package1"
              data-bs-toggle="pill"
              data-bs-target="#pill-body1"
              type="button"
              role="tab"
              aria-controls="pill-body1"
              aria-selected="true"
            >
              <i className="fa-solid fa-circle-info"></i> Workshop info
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-package2"
              data-bs-toggle="pill"
              data-bs-target="#pill-body2"
              type="button"
              role="tab"
              aria-controls="pill-body2"
              aria-selected="false"
            >
              <i className="fa-solid fa-bag-shopping"></i> How to book
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-package3"
              data-bs-toggle="pill"
              data-bs-target="#pill-body3"
              type="button"
              role="tab"
              aria-controls="pill-body3"
              aria-selected="false"
            >
              <i className="fa-solid fa-location-dot"></i> Where & when
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="pills-package4"
              data-bs-toggle="pill"
              data-bs-target="#pill-body4"
              type="button"
              role="tab"
              aria-controls="pill-body4"
              aria-selected="false"
            >
              <i className="fa-solid fa-list"></i> Key facts
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">

          {/* workshop info tab */}
                <div
                className="tab-pane fade show active package-info-tab"
                id="pill-body1"
                role="tabpanel"
                aria-labelledby="pills-package1"
                >

                <h3 className="d-subtitle">About this workshop</h3>
                <div className="workshop_bodytext" dangerouslySetInnerHTML={{ __html: props.workshop.description }} />

                {props.workshop.mentorship == 1 && (
                  <>
                  <h3 className="d-subtitle mt-20">Post-workshop mentorship</h3>
                  <div className="workshop_bodytext">
                    After the workshop finishes, you'll have the option to add a course of <strong>individual mentorship</strong> with your tutor. You can book one session, or a program of regular meetups, or whatever suits your schedule. It's a great way to get feedback on your work, get guidance on your creative path, and build your networks.<br /><br />There's no need to decide now - you can sign up for a program of mentorship at any time during or after the workshop. Mentorship is only available as a post-workshop extension, not as a standalone thing.
                  </div>
                  </>
                )}

                </div>


                {/* how to book tab */}
          <div
            className="tab-pane fade package-plan-tab"
            id="pill-body2"
            role="tabpanel"
            aria-labelledby="pills-package2"
          >
            <h3 className="d-subtitle">How to book</h3>
            <div className="workshop_bodytext" dangerouslySetInnerHTML={{ __html: props.workshop.howtobook }} />
          </div>

          {/* where when tab */}
          <div
            className="tab-pane fade package-gallary-tab"
            id="pill-body3"
            role="tabpanel"
            aria-labelledby="pills-package3"
          >

            <h3 className="d-subtitle">Where & when</h3>
            <div className="workshop_bodytext" dangerouslySetInnerHTML={{ __html: props.workshop.wherewhentext }} />


          </div>

          <div
            className="tab-pane fade package-location-tab"
            id="pill-body4"
            role="tabpanel"
            aria-labelledby="pills-package4"
          >
            <h3 className="d-subtitle">Key facts</h3>
            <div className="workshop_bodytext">
              <table className="table package-info-table mb-0">
                <tbody>
                  <tr>
                    <th>Course type</th>
                    <td><div dangerouslySetInnerHTML={{ __html: props.workshop.ctype }} /></td>
                  </tr>
                  <tr>
                    <th>Dates</th>
                    <td><div dangerouslySetInnerHTML={{ __html: props.workshop.keyfact_dates }} /></td>
                  </tr>
                  <tr>
                    <th>Student level</th>
                    <td>{props.workshop.student_level}</td>
                  </tr>
                  <tr>
                    <th>Equipment</th>
                    <td>{props.workshop.equipment}</td>
                  </tr>
                  <tr>
                    <th>Post-workshop support</th>
                    <td>{props.workshop.post_course}</td>
                  </tr>
                  {props.workshop.mentorship == 1 && (
                  <tr>
                    <th>Post-workshop mentorship</th>
                    <td>After the workshop, you will have the opportunity to book a flexible program of individual mentorship sessions with {props.workshop.tutors}</td>
                  </tr>
                  )}

                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <React.Fragment>
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId="L61p2uyiMSo"
          onClose={() => setOpen(false)}
        />
      </React.Fragment>
    </>
  );
}

export default PackageDetailsTab;
